export default {
  'homepage':{
    'titolo':'Â¡LibÃ©rate!',
    'sottotitolo':'Conocer gente nueva',
    'accedi':'Iniciar sesiÃ³n',
    'registrati':'Registrarse',
    'gia_registrato':'Si ya estÃ¡ registrado para el servicio, inicie sesiÃ³n:',
    'non_registrato':'Si aÃºn no estÃ¡ registrado, regÃ­strese ahora y comience a conocer gente nueva.',
    'perche':'Por quÃ© elegir',
    'trova':'Encuentra el single adecuado para ti',
    'sicurezza':'Su seguridad es importante para nosotros',
    'aumenta_visibilita':'Incrementa la visibilidad de tu perfil',
    'cerca_persona_adatta':'Encuentra la persona adecuada para ti',
    'desc_sicurezza':'La protecciÃ³n de nuestros clientes es una prioridad absoluta y hacemos todo lo posible para garantizar la mÃ¡xima seguridad en nuestro sitio. Moderamos cada foto de perfil y descripciÃ³n. La protecciÃ³n de sus datos personales es nuestra prioridad.',
    'desc_visibilita':'Cree el perfil perfecto para sus reuniones en lÃ­nea. Â¡Cuantas mÃ¡s visitas a tu perfil y en consecuencia tendrÃ¡s mÃ¡s posibilidades de conocer gente interesante!',
    'desc_persona_adatta':'Encuentra a la persona adecuada para ti gracias a la bÃºsqueda detallada y descubre nuestra selecciÃ³n personalizada de perfiles detallados.',
    'sezione_coppie':'Parejas que se conocieron en $servizio$'
  },
  'navbar_mobileNew': {
    'cerca': 'Buscar',
    'messaggi': 'Mensajes',
    'profilo':'Perfil',
    'vip':'VIP',
    'registrati':'RegÃ­strate',
    'incentive_menu':'Agregar crÃ©ditos de mensajes',
    'messaggi_restanti':'Mensajes de crÃ©ditos',
    'rimanenti':'restantes',
    'logout':'Cerrar sesiÃ³n',
    'attiva_notifiche':'Telegram',
    'crediti':'CrÃ©ditos',
    'titolo_cerca':'BUSCAR',
    'titolo_match':'PARTIDO',
    'titolo_messaggi':'MENSAJES',
    'titolo_notifiche':'NOTIFICACIONES',
    'titolo_avvisi':'AVISOS',
    'titolo_profilo':'PERFIL',
    'titolo_rateplan':'AUMENTAR CRÃ‰DITOS',
    'profilo_angel':'USER PROFILE',
    'diventa_premium':'CONVIÃ‰RTETE EN PREMIUM',

  },
  'chat_content': {
    'disponibile': 'en linea',
    'inserire_numero':'Para ingresar el nÃºmero debe ser un usuario verificado como <strong>$angel$</strong>',
    'registrarti':'tienes que elegir un plan de suscripciÃ³n',
    'scrivi_un_messaggio':'Escribe un mensaje...',
    'rompi_il_ghiaccio':'Â¡Romper el hielo!',
    'prova_con':'Pruebe uno de estos mensajes que todos usan. ElÃ­gelo para enviarlo',
    'messaggio1':'Hola, me gustarÃ­a ver tus fotos privadas.',
    'messaggio2':'Â¿CÃ³mo estÃ¡s? Â¿Quieres hablar un poco?',
    'messaggio3':'He visto tu perfil y me gustarÃ­a conocerte mejor',
    'hook_blurred':'Lee el mensaje',
    'non_essere_timido':'$angel$ es disponible.<br>Â¡EnvÃ­ale un mensaje!',
    'sta_scrivendo':'esta escribiendo..',
    'ha_visitato':'<i class="far fa-eye"></i> ha visitado tu perfil',
    'elimina_chat':'Eliminar chat',
    'sei_sicuro':'¿Estás seguro?',
    'si':'Sí',
    'no':'No'
  },
  'profilo': {
    'username': 'Username',
    'cambia': 'aÃ±adir',
    'eta': 'AÃ±os',
    'email': 'Correo electrÃ³nico',
    'cerco': 'Busco',
    'sono': 'Soy',
    'inserisci_numero': 'Ingrese su nÃºmero telefÃ³nico',
    'inserisci_username': 'Ingrese su nombre de usuario',
    'inserisci_email': 'Ingrese su correo electrÃ³nico',
    'inserisci_citta': 'Ingrese su ciudad',
    'inserisci_eta': 'Su edad',
    'salva': 'Guardar cambios',
    'citta': 'Ciudad',
    'uomo':'Hombre',
    'donna':'Mujer',
    'scegli':'Elegir..',
    'solo_immagini': 'Solo se permiten imÃ¡genes',
    'grandezza_file':'La foto debe tener menos de 10MB',
    'foto_non_conforme':'Foto rechazada: viola las normas de la plataforma',
      'foto_chat_non_conforme':'Mensaje no enviado: la foto viola las políticas de la plataforma',
    'mail_esistente':'El correo electrÃ³nico seleccionado ya existe',
    'seleziona_altra_mail':'Seleccione otro correo electrÃ³nico para actualizar correctamente su perfil',
    'titolo_ok':'Cambios realizados con Ã©xito',
    'testo_ok':'Los cambios en su perfil se han realizado correctamente.',
    'crediti_messaggi':'CrÃ©ditos',
    'aggiungi':'Agregar',
    'disiscrizione':'Darse de baja',
    'header_disiscrizione':'Cerrar servicio',
    'titolo_disiscrizione':'Â¿Quieres continuar con la baja?',
    'descrizione_disiscrizione':'PerderÃ¡s todas las oportunidades de chatear con nuevas chicas y tener nuevas aventuras picantes.',
    'disiscrizione_ok':'La cancelaciÃ³n de la suscripciÃ³n fue exitosa',
    'disiscrizione_ko':'Hubo un error en la fase de cancelaciÃ³n de suscripciÃ³n, comunÃ­quese con el servicio de atenciÃ³n al cliente.',
    'descrizione':'DescripciÃ³n',
    'cosa_cerco':'Â¿EstÃ¡s buscando?',
    'cambia_foto':'Sube foto',
    'regione':'Elige tu comunidad',
    'utente_free':'Eres un usuario gratuito y todavÃ­a tienes <strong>$icebreacker$</strong> para romper el hielo (iniciar una charla) y <strong>$messaggi$</strong> mensaje para responder. ConviÃ©rtase en un usuario premium tener todas las posibilidades para dar en el blanco',
    'diventa_premium':'ObtÃ©n premium ahora!',
    'impostazioni_profilo':'ConfiguraciÃ³n de perfil',
    'disattiva_profilo':'Desactivar perfil',
    'disattiva_profilo_ok':'Tu perfil ha sido desactivado y ya no es visible para otros usuarios. SerÃ¡s redirigido a la pÃ¡gina de inicio. Para reactivarlo, contacta con el servicio de atenciÃ³n al cliente.',
    'torna_home':'Volver a la pÃ¡gina de inicio',
    'sei_sicuro_disattiva_profilo':'Â¿EstÃ¡s seguro de que quieres desactivar tu perfil?',
    'spiegazione-disattiva_profilo':'<div class="testo_popup_disattivazione">Al desactivar tu perfil, ya no podrÃ¡s:<ul><li>acceder al servicio</li><li>ser visible para otros usuarios</li><li>usar tus crÃ©ditos</li></ul>. Para reactivar tu perfil, deberÃ¡s contactar con atenciÃ³n al cliente - <span style="font-weight:bold">Â¿Quieres continuar?</span></div>',
    'si': 'SÃ­',
    'no': 'No',
    'ricevute_acquisti': 'Recibos de compras',
    'gestione_notifiche': 'GestiÃ³n de notificaciones',
    'telegram': 'Telegram',
    'notifiche_push': 'Notificaciones push',
    'email_tracking': 'Pixel tracking',
    'stato_profilo': 'Estado del perfil',
    'prossimo_addebito': 'PrÃ³ximo cargo',
    'supporto': 'Soporte',
  },
  'user': {
    'chat': 'Chat',
    'mi_piace': 'Me gusta',
    'anni': 'AÃ±os',
    'posizione': 'PosiciÃ³n',
    'capelli': 'Cabello',
    'altezza':'Altura',
    'peso': 'Peso',
    'descrizione': 'DescripciÃ³n',
    'cerca': 'Buscando',
    'vicino_a_te':'Cerca de usted',
    'messaggi_rimanenti':'Mensajes restantes',
    'incentive':'RegÃ­strate para recibir mÃ¡s mensajes',
    'persona_interessata':'Â¡Esta persona puede estar interesada en ti!',
    'registrati_adesso':'RegÃ­strate ahora',
    'messaggi_illimitati':'de esta manera, puede enviarle mensajes ilimitados y programar un encuentro',
    'blond':'Rubio',
    'brown':'CastaÃ±o',
    'red':'Rojo',
    'darkblond':'Rubio oscuro',
    'black':'Negro',
    'colored':'TeÃ±ido',
    'mi_piace_inviato':'Hemos enviado tu "Me gusta" â¤ï¸',
    'scrivile_in_privato':'EscrÃ­bele en privado',
    'uomo': 'Hombre',
    'donna': 'Mujer',
    'segnala_blocca': 'Bloquear o reportar',
    'utente_bloccato': '🚫 Usuario bloqueado y reportado, no podrá contactarte',
  },
  'signup': {
    'registrazione': 'Registro',
    'immediata': 'Inmediato',
    'incontri_segreti': 'Encuentros secretos y discretos...',
    'trova_ragazze': 'Ãšnete a mujeres que, mediante una reuniÃ³n discreta, buscan escapar por unas horas.',
    'scegli_una_password': 'Elije una contraseÃ±a',
    'continua': 'CONTINUAR'
   },
  'popupHook': {
    'utente_registrato': 'es un usuario VERIFICADO',
    'incentive_1': 'Para poder enviar otros mensajes de chat y hablar con otras mujeres disponibles, regÃ­strate gratis.',
    'incentive_2': 'Para poder ver su nÃºmero de mÃ³vil, regÃ­strate ahora.',
    'altri_profili': 'Los usuarios premium pueden ver otros perfiles',
    'incentive_3': 'Para conocer las otras chicas disponibles, regÃ­strate ahora',
    'utenti_usano': 'La mayoria de nuestros usuarios usan',
    'si_raccomanda': 'Se recomienda registrarse',
    'cambiar_profilo': 'Los usuarios premium pueden cambiar su perfil',
    'per_cambiar_profilo': 'Para poder cambiar su perfil y agregar el contacto de',
    'registrati_adesso': 'regÃ­strate ahora',
    'gia_account': 'Ya tienes una cuenta?',
    'bentornato': 'Â¡Dar una buena acogida! Ingrese sus credenciales para acceder al servicio',
    'registrati_home': 'Â¡Haz amigos de inmediato y conoce gente en tu Ã¡rea!',
    'accedi_subito': 'Iniciar sesiÃ³n',
    'continua':'CONTINÃšA',
    'blurred_title':'Mensaje visible solo para usuarios verificados o premium',
    'blurred_body':'ha expresado su deseo de chatear solo con usuarios verificados como ella.',
    'blurred_incentive':'Â¿Quieres ver respuesta de <strong>$angel$</strong> y enviarle mÃ¡s mensajes inmediatamente?',
    'espresso_desiderio': 'ha expresado el deseo de conocer SOLO a usuarios verificados como ella',
    'vuoi_vedere':'Â¿Quieres ver sus fotos, sus detalles y enviarle un mensaje de texto de inmediato?',
    'verifica_ora':'Verifica tu cuenta ahora',
    'diventa_premium':'Se convierte en premium',
    'verifica_profilo':'VERIFICA AHORA TU CUENTA',
    'messaggio_non_mandato':'El mensaje no se puede enviar',
    'attiva_pass':'El mensaje por <strong>$angel$</strong> no puede enviarse.<br>Activa tu PASE y envÃ­alo de inmediato',
    'attiva_lettura':'Â¿Quieres saber si <strong>$angel$</strong> lee tus mensajes?',
    'ti_piace': 'Te gusta',
    'attiva_generico':'Activa tu PASE a LIKE ilimitado, CHATEA con quien quieras, VER todos los perfiles',
    'donne_regione':'Los usuarios VIP pueden ver perfiles de otras regiones',
    'sottotitolo_regione':'Para ver a todas las mujeres en lÃ­nea, de todas las comunidades, se recomienda convertirse en VIP',
    'messaggio_sospeso':'1 mensaje pendiente',
    'attiva_pass_senza_limiti':'Activa tu <strong>PASE</strong> para chat ilimitado',
    'per_scoprire':'Para descubrir todo de ella, <strong>$angel$</strong> quiere que verifiques tu cuenta ahora mismo.',
    'la_vuoi_conoscere':'Â¿QUIERES CONOCER ',
    'imposta_regione':'Seleccione una comunidad donde desea encontrar mujeres para su prÃ³xima cita',
    'quasi_terminato':'Â¡Casi has terminado!',
    'non_lasciare_sospeso': 'Â¡No dejes <strong>$angel$</strong> en suspenso!',
    'altri_uomini': '<i>Otros hombres en lÃ­nea ahora podrÃ­an escribirle.</i>',
    'utente_disabilitato':'Su cuenta ha sido desactivada. ComunÃ­quese con el servicio de atenciÃ³n al cliente para obtener mÃ¡s informaciÃ³n',
   },
   'popupNotifica':{
     'hai_ricevuto_messaggio':'Recibiste un mensaje',
     'da':'de',
     'rispondi':'Contesta',
     'profilo':'Perfil',
     'hai_ricevuto_like':'Â¡te ha enviado un LIKE!',
     'risposta_a_like':'respondiÃ³ a tu LIKE! EnvÃ­ale un mensaje de texto de inmediato',
     'ha_guardato_tuo_profilo':'ha visto tu perfil recientemente',
     'avvisami_risposta':'Avísame cuando responda',
     'avvisami_novita':'Avísame cuando haya novedades',
     'visualizza':'Ver perfil'
   },
   'popupInfo':{
    'anni': 'AÃ±os',
   },
   'popupGenerico':{
    'chiudi': 'Cerrar',
    'cambia_carta':'Cambiar tarjeta',
    'bentornato':'Â¡Bienvenido de nuevo, te extraÃ±amos!',
    'regalo_messaggi':'Por este motivo te hemos dado algunos crÃ©ditos. ðŸ’° Â¡Chatea inmediatamente con quien quieras!',
   },
   'popupFoto':{
      'carica_foto': 'Sube una foto tuya <br /> para completar tu perfil',
      'incentivo':'Â¡Los usuarios con foto <br/>reciben <strong>7 veces mÃ¡s mensajes!</strong>',
      'lo_faro_dopo':'Lo harÃ© despuÃ©s'
    },
   'signupForm':{
     'caricando':'Cargando...',
     'scegli_una_password':'Elije una contraseÃ±a*',
     'registrati_gratis':'RegÃ­strate ahora gratis',
     'accedi':'Iniciar sesiÃ³n',
     'gia_registrato':'Â¿Ya registrado?',
     'iscriviti':'Â¿No estas registrado?',
     'password':'ContraseÃ±a',
     'password_dimenticata':'Â¿Se te olvidÃ³ tu contraseÃ±a?',
     'indietro':'AtrÃ¡s para iniciar sesiÃ³n',
     'invia':'Enviar',
     'introduci_mail_reset_password':'Ingrese su correo electrÃ³nico para iniciar el proceso de restablecimiento de contraseÃ±a',
     'email_inviata':'Se le ha enviado un enlace a su direcciÃ³n de correo electrÃ³nico para restablecer su contraseÃ±a.',
     'utente_inesistente':'La direcciÃ³n ingresada no existe',
     'mail_password_errati':'El correo electrÃ³nico o la contraseÃ±a son incorrectos.',
     'sono': 'Soy',
     'cerco':'Buscando',
     'citta':'Escribe tu ciudad',
     'email':'Ingresar tu correo electrÃ³nico*',
     'suggerimento_citta':'Ciudad no encontrada',
     'errore_citta':'Elige tu comunidad',
     'errore_email':'Complete el campo de correo electrÃ³nico',
     'errore_password':'Complete el campo de contraseÃ±a',
     'regione':'Elige tu comunidad',
     'es': 'Introduce tu edad',
     'errore_sono':'Completa el campo "Soy"',
    'errore_cerco':'Completa el campo "Busco"',
    'errore_terms': 'Para continuar, debes aceptar los tÃ©rminos y condiciones generales del servicio',
    'accetto_clausole': 'Acepto expresamente las clÃ¡usulas opresivas enumeradas en el art.14 de los <a href="$terms$">TÃ©rminos Generales</a> del servicio',
    'acconsento_trattamento': 'Consiento el tratamiento de mis datos personales con fines promocionales como se indica en la <a href="$privacy$">PolÃ­tica de Privacidad</a>',
    'acconsento_comunicazione': 'Consiento la comunicaciÃ³n de mis datos personales a terceros para sus fines de marketing, como se indica en la <a href="$privacy$">PolÃ­tica de Privacidad</a>',
    'dichiaro_maggiorenne': 'Confirmo que soy mayor de edad',
    'cliccando_accetti':'Al hacer clic en Registrarse declaras que has leÃ­do y aceptado la <a href="$privacy$">PolÃ­tica de Privacidad</a> y los <a href="$terms$">TÃ©rminos y Condiciones</a> del servicio',
    'orientamenti_sessuali':'Doy mi consentimiento expreso para el tratamiento de datos capaces de revelar mis preferencias y orientaciones sexuales, como se indica en la <a href="$privacy$">PolÃ­tica de Privacidad</a>'
   },
   'photoItem':{
    'bottone_chat':'EnvÃ­a mensaje',
    'bottone_like':'Me Gusta',
    'bottone_profilo':'Perfil',
    'registrati_gratis':'RegÃ­strate ahora gratis',
    'anni':'aÃ±os'
  },
  'create_list':{
    'hai_ricevuto_like':'Ha visitado tu perfil',
    'hai_ricevuto_visita':'Ha visitado tu perfil',
    'ha_rispost_like':'Ha respondido a tu like',
    'non_letto':'NO LEÃDO',
    'nessuna_notifica':"AÃºn no has recibido ninguna notificaciÃ³n",
    'nessun_messaggio':'TodavÃ­a no has recibido ningÃºn mensaje, agrega una foto de perfil y usa la pÃ¡gina Match para enviar algunos Me gusta.',
    'mi_piace':'Me gusta',
    'elimina_chat':'Eliminar chat',
    'sei_sicuro':'¿Estás seguro?',
    'si':'Sí',
    'no':'No'

  },
   'navbar_desktop':{
    'cerca': 'Buscar',
    'messaggi': 'Mensajes',
    'profilo':'Perfil',
    'registrati':'RegÃ­strate',
    'vip':'VIP',
    'incentive_menu':'RegÃ­strate para recibir mÃ¡s mensajes',
    'messaggi_restanti':'Mensajes de crÃ©ditos',
    'rimanenti':'restantes',
    'logout':'Cerrar sesiÃ³n',
    'attiva_notifiche':'Notificaciones',
    'notifiche':'Notificaciones',
    'match':'Match',
  },
  'creditCardForm':{
    'numero_carta': 'NÃºmero de tarjeta',
    'nome_intestatario': 'Nombre del titular',
    'cognome_intestatario': 'Apellido del titular',
    'scadenza': 'Caducidad',
    'CVC': 'CVC',
    'continua': 'CONTINUAR',
    'tasto_riprova': "REINTENTAR",
    'carta': 'Tarjeta de crÃ©dito',
    'nome': 'Nombre',
    'cognome': 'Apellido',
    'disclaimer_fluxid0000': 'Al hacer clic en continuar aceptas los <a href="$terms$"> TÃ©rminos y Condiciones</a> y la <a href="$privacy$"> PolÃ­tica de Privacidad </a>',
    'disclaimer': 'Al hacer clic en continuar aceptas los <a> TÃ©rminos y Condiciones</a> y la <a> PolÃ­tica de Privacidad </a>',
    'pagamento_sicuro': 'Pago Seguro',
    'descriptor': 'Nos preocupamos por tu vida privada y respetamos tu privacidad. El cargo realizado en tu tarjeta de crÃ©dito aparecerÃ¡ bajo el nombre $descriptor$ en tu extracto',
    'errore': 'Error',
    'qualcosa_storto': 'Algo saliÃ³ mal',
    'cambia_carta': 'Prueba inmediatamente con otra tarjeta para continuar chateando o cambia el mÃ©todo de pago',
    'cvv_errato': 'El CVV/CVC no es correcto. Corrige el CVV/CVC o cambia el mÃ©todo de pago para continuar chateando.',
    'fondi_insufficenti': 'Parece que tu tarjeta no tiene fondos o ha alcanzado el lÃ­mite de gasto. Te invitamos a verificar o cambiar el mÃ©todo de pago',
    'persa_rubata': 'Tarjeta no utilizable. Prueba inmediatamente con otra tarjeta o cambia el mÃ©todo de pago para continuar chateando',
    'scaduta': 'La tarjeta que has utilizado ha caducado. Actualiza la tarjeta o cambia el mÃ©todo de pago para continuar chateando',
    'gia_processata': 'Esta tarjeta ya ha sido rechazada. Por favor, prueba con una nueva tarjeta.',
    'numero_carta_non_valido': 'Verifica que los datos de tu tarjeta sean correctos para continuar chateando',
    'riprova': 'Intento adicional requerido. En los prÃ³ximos pasos serÃ¡s redirigido al sitio de tu banco para verificar tu identidad. PodrÃ¡s recibir un SMS o una notificaciÃ³n en la app de tu banco.',
    'blacklisted': 'Tu tarjeta estÃ¡ en la lista negra',
    'generico': 'Tarjeta rechazada. Prueba inmediatamente con otra tarjeta para continuar chateando o cambia el mÃ©todo de pago',
    '3ds': 'Intento adicional requerido',
    'verifica_fallita': 'La verificaciÃ³n requerida por tu banco para confirmar tu identidad no fue exitosa',
    'success': 'Gracias, el pago se realizÃ³ con Ã©xito. ContinÃºa chateando y buena suerte para tu prÃ³xima cita',
    'consiglio_generico': 'Prueba inmediatamente con otra tarjeta para continuar <span className="special_bold">CHATEANDO</span>',
    'consiglio_insufficent_fund': 'Tu tarjeta actualmente no es utilizable por insuficiencia de fondos, cambia de tarjeta para continuar chateando',
    'consiglio_3ds': 'En los prÃ³ximos pasos serÃ¡s redirigido al sitio de tu banco para verificar tu identidad. Confirma la notificaciÃ³n que llegarÃ¡ de tu banco',
    'disclaimer_verifica_eta': 'Al hacer clic en CONTINUAR, aceptas nuestras Condiciones de uso y la PolÃ­tica de privacidad, y puede cobrarse una tarifa de verificaciÃ³n de 0,01â‚¬.',
    'descrizione_pending': 'Parece que tu banco estÃ¡ tardando mÃ¡s de lo previsto. ContinÃºa navegando, te daremos los crÃ©ditos tan pronto como se apruebe la operaciÃ³n',
    'titolo_cvv': 'Corrige CVV/CVC',
    'titolo_fondi_insufficenti': 'Â¿Tarjeta sin fondos?',
    'titolo_persa_rubata': 'Tarjeta no utilizable',
    'titolo_generico': 'Tarjeta rechazada',
    'titolo_pending': 'La operaciÃ³n aÃºn estÃ¡ en curso',
    'titolo_success': 'Pago aceptado',
    'titolo_verifica_fallita': 'Error de compra',
    'titolo_riprova': 'Intento adicional requerido',
    'cambia_metodo_pagamento': 'Este mÃ©todo de pago ha sido bloqueado por un nÃºmero excesivo de intentos fallidos. Por favor, prueba con otro mÃ©todo de pago.',
    'open': 'Estamos esperando que tu banco confirme el pago. Los crÃ©ditos se acreditarÃ¡n en caso de resultado positivo. Generalmente esto requiere algunos minutos',
    'titolo_open': 'Pago pendiente',
    'titolo_canceled': 'Pago cancelado',
    'descrizione_canceled': 'Has cancelado el pago. IntÃ©ntalo de nuevo para continuar chateando',
    'titolo_problemi_api': 'TransacciÃ³n fallida',
    'descrizione_problemi_api': 'Parece que hay problemas con este mÃ©todo de pago. Prueba con otro mÃ©todo',
    'pagamento_in_corso':'Pago en curso..',
    'attendi_un_minuto':'Un pago es ya estÃ¡ en curso, espera un minuto antes de hacer mÃ¡s compras.',
    'waiting':'Estamos esperando que tu banco confirme el pago. Por favor, espera un momento.',
    'titolo_waiting': 'Solo un momento por favor',
    'titolo_pacchettone': 'Â¡Felicidades!',
    'descrizione_pacchettone': 'Queremos recompensar tu compromiso<br>con una <strong>sorpresa especial</strong> para ti!',
    'prendine_un_altro':'Â¡TÃ³malo otro a mitad de precio!',
    'disclaimer_opale': 'Prueba gratuita del servicio de coaching de seducciÃ³n online.<br> La prueba de 10 dÃ­as te permite hablar con coaches todos los dÃ­as, recibir consejos personalizados y acceder a artÃ­culos exclusivos. Tras el perÃ­odo de prueba, el servicio se renueva automÃ¡ticamente a â‚¬19.90 cada 14 dÃ­as, hasta que se cancele.'
  },
  'payment_page':{
    'pagamento_sicuro':'Pago seguro',
    'dati_protetti':'Datos de la tarjeta protegidos con cifrado SSL',
    'non_paghi_nulla':'Nota: No pagarÃ¡ nada para verificar su cuenta. Solo agregando una tarjeta activa puedes demostrar que eres mayor de edad como los usuarios ya verificados',
    'verifica_profilo':'PROCEDIMIENTO DE VERIFICACIÃ“N DE CUENTA',
    'stai_acquistando':'Estas comprando',
    'procedura':'TrÃ¡mite de verificaciÃ³n de edad GRATIS',
    'nessun_addebito':'<strong>â‚¬ 0.00 - Sin cargos</strong><br>Â¡SOLO ADULTOS!',
    'inserisci_e_verifica':'Inserta tu tarjeta<br>y verifica que eres mayor de <strong>18 aÃ±os</strong>',
    'nessun_abbonamento':'Esto NO es una suscripciÃ³n. Su tarjeta de crÃ©dito <strong>NO</strong> tendrÃ¡ devoluciones de cargo.',
    'scegli_metodo':'Â¿CÃ³mo quieres continuar?',
     "attiva_pass": "Activa tu <strong>PASE</strong> para chatear sin lÃ­mites",
     'coda_discplaimer':'En caso de compra con PayPal la venta del servicio y la transacciÃ³n son gestionadas directamente por Coda Netherlands Holdings B.V.',
     'garanzia_di_rimborso':'GarantÃ­a de reembolso',
     'garanzia_di_rimborso_text':'Tienes derecho a un reembolso completo<br/> si no estÃ¡s satisfecho',
     'processando_pagamento':'Estamos procesando tu pago',
  },
  'pianiAbbonamento':{
    'disclaimer':'Al elegir un plan de suscripciÃ³n, acepta los <a href="/legal/terms">TÃ©rminos y condiciones</a> y la <a href="/legal/terms#billingPolicy">PolÃ­tica de facturaciÃ³n</a>.',
    'disclaimer2':'*Todos los planes incluyen renovaciÃ³n automÃ¡tica.',
    'disclaimer3':'**Al elegir un plan de suscripciÃ³n, acepta los <a href="/legal/terms">TÃ©rminos y condiciones</a> y la <a href="/legal/terms#billingPolicy">PolÃ­tica de facturaciÃ³n</a>.',
    'disclaimer4':'***Al elegir un plan de suscripciÃ³n, acepta los <a href="/legal/terms">TÃ©rminos y condiciones</a> y la <a href="/legal/terms#billingPolicy">PolÃ­tica de facturaciÃ³n</a>.',
    'disclaimer5': 'Todos los planes se renuevan automÃ¡ticamente.',
    'errore':'Error',
    'qualcosa_storto':'Algo saliÃ³ mal',
    'header_chatta_senza_limiti':' Â¿Quieres chatear sin lÃ­mites con <strong>$angel$</strong>?',
    'header_fine_like':'Â¿Quieres enviar Me gusta sin lÃ­mites?',
    'header_messaggio_offuscato':' Â¿Quieres leer el mensaje de <strong>$angel$</strong>?',
    'header_paginazione':'Â¿Quieres ver todas las<br> mujeres en lÃ­nea?',
    'header_cambio_regione':'Â¿Quieres ver a las<br> mujeres de otra comunidad?',
    'testo_verifica_eta':'Para garantizar la <strong> seguridad </ strong> de nuestros usuarios <strong> debemos verificar que usted ambos adultos </ strong>',
    'testo_bottone_verifica_eta':'TENGO 18+ AÃ‘OS',
    'aggiungiamo_crediti':'Estamos agregando tus crÃ©ditos',
    'altri_uomini': '<i>Otros hombres podrÃ­an escribirle</i>',
    'vuoi_continuare': 'Â¿Quieres continuar chateando con <strong>$angel$</strong> y con todas las demÃ¡s mujeres?',
    'redirigendo':'Redirigiendo al pago...',
    'crediti': 'CrÃ©ditos',
    'approfitta_ora': 'Aprovecha ahora de <strong>esta oferta</strong><br />para continuar recibiendo beneficios.',
    'like_illimitati': 'Likes ilimitados<br />Chatea con quien quieras',
  },
  'passwordReset':{
    'caricando':'Cargando...',
    'procedura':'Ingrese la nueva contraseÃ±a en los campos',
    'password':'Nueva contraseÃ±a',
    'ripeti':'Repite la contraseÃ±a',
    'invia':'Enviar',
    'non_corrispondono':'La contraseÃ±a vencida sin corregir',
    'passwordCambiata':'ContraseÃ±a reemplazada con Ã©xito. Ir a la pÃ¡gina de inicio de sesiÃ³n',
    'token_expired':'El procedimiento de restablecimiento de contraseÃ±a ya se ha realizado. IntÃ©ntalo de nuevo'
  },
  'errorHandler':{
    'email_esistente':'Tu correo electrÃ³nico ya existe. Intenta iniciar sesiÃ³n o recuperar su contraseÃ±a</a>',
    'utente_non_trovato':'Usuario o ContraseÃ±a invalido',
    'qualcosa_storto':'Algo saliÃ³ mal. Por favor, vuelva a intentarlo',
    'fingerprint':'Resulta que ya estÃ¡s registrado con el correo electrÃ³nico $email$, intenta iniciar sesiÃ³n o recupera tu contraseÃ±a',
    'email_non_valida':'El correo electrÃ³nico estÃ¡ escrito incorrectamente. PuntuaciÃ³n correcta y caracteres especiales.',
    'email_vietata':'Este correo electrÃ³nico no se puede utilizar. Usa otro',
    'troppi_tentativi':'Has realizado demasiados intentos de registro.',
    'account_disabilitato':'Su cuenta ha sido desactivada. ComunÃ­quese con el servicio de atenciÃ³n al cliente para obtener mÃ¡s informaciÃ³n',
    'welcome_gia_inviata': 'El correo de bienvenida ya ha sido enviado a esta direcciÃ³n <strong class="blink">revisa la carpeta <blink>Spam</blink> o <blink>Correo no deseado</blink></strong>.'
  },
  'logo':{
    'url':'/img/logo_es.png'
  },
  'ok':{
    'congratulazioni':'Â¡Felicidades!',
    'utente_premium':'Gracias por su compra',
    'bottone_chat':'Disfruta el servicio!'
  },
  'ko':{
    'ops':'Â¡UPS!!',
    'qualcosa_storto':'Algo saliÃ³ mal',
    'bottone_indietro':'IntÃ©ntalo de nuevo',
  },
  'searchFilters':{
    'titolo_popup':'Seleccione la comunidad en la que desea buscar mujeres disponibles',
    'seleziona':'Seleccione',
    'seleziona_regione':'Seleccione comunidad',
  },
  'footer':{
    'faq':'Preguntas mÃ¡s frecuentes',
    'termini':'TÃ©rminos y condiciones',
    'privacy':'PolÃ­tica de privacidad',
    'cookie':'PolÃ­tica de cookies',
    'contact_us':'ContÃ¡ctenos',
  },
  'chats':{
    'nessun_messaggio':'AÃºn no tienes ningÃºn mensaje'
  },
  'contactUs':{
    'contattaci':'ContÃ¡ctenos',
    'per_ricevere':'Para recibir asistencia directa contÃ¡ctenos utilizando el formulario apropiado en esta pÃ¡gina o en las siguientes direcciones',
    'caricando':'Cargando...',
    'grazie':'Gracias, tu mensaje fue tomado sobre'
  },
  'landingAutologin':{
    'titolone': 'IMPORTANTE',
    'testo':'<strong>$angel$</strong> te estÃ¡ buscando. Recuerda que tÃº y otros usuarios de este club buscan diversiÃ³n, no una relaciÃ³n. Muchos estÃ¡n casados â€‹â€‹y son infelices, otros son madres solteras. Todos viven en $regione$ si conoces a uno o mÃ¡s de ellos te pedimos que mantengas su identidad en secreto dentro de este club de sexo. Para ver el mensaje <strong>$angel$</strong> y aceptar las reglas del club, haga clic en continua.',
    'pulsante':'CONTINÃšA'
  },
  'landingAutosignup':{
    'titolone': 'IMPORTANTE',
    'testo':'Recuerda que tÃº y otros usuarios de este club buscan diversiÃ³n, no una relaciÃ³n. Muchos estÃ¡n casados â€‹â€‹y son infelices, otros son madres solteras. Todos viven en tu comunidad si conoces a uno o mÃ¡s de ellos te pedimos que mantengas su identidad en secreto dentro de este club de sexo. Para continuar y aceptar las reglas del club, elige la comunidad y haga clic en continua.',
    'pulsante':'CONTINÃšA'
  },
  'telegramPush':{
    'titolo':'No te pierdas ningún mensaje',
    'titolo_nome':'$nome$ te responderá.',
    'sottotitolo':'¿Dónde quieres enterarte al instante?',
    'consigliato':'Recomendado',
    'presto':'Pronto',
    'push_titolo':'Notificaciones en el móvil',
    'push_testo':'Un toque, sin instalar ninguna app.',
    'push_attivo':'Activadas. Te avisamos en el móvil.',
    'push_ios':'Primero añade el sitio a la pantalla de inicio.',
    'telegram_testo':'Instantáneo y discreto. Lo desactivas cuando quieras.',
    'telegram_attivo':'Activo. Te avisamos aquí.',
    'whatsapp_testo':'El mensaje llega donde ya chateas.',
    'whatsapp_messaggio':'¡Hola! Activa las notificaciones para $email$',
    'passo_1':'Toca Compartir, abajo en Safari',
    'passo_2':'Elige "Añadir a pantalla de inicio"',
    'passo_3':'Abre el sitio desde el icono y vuelve aquí',
    'push_negato':'Has bloqueado las notificaciones: vuelve a activarlas en los ajustes del navegador.',
    'push_non_supportato':'Este navegador no admite notificaciones. Abre el sitio en Chrome o Safari, o elige Telegram.',
    'push_errore':'No hemos podido activarlas. Inténtalo de nuevo en un momento.',
    'fatto':'Listo. A partir de ahora te avisamos aquí.',
    'torna_chat':'Volver al chat',
    'torna_chat_nome':'Volver al chat con $nome$'
  },
  'cookie':{
    'disclaimer': '<p>Este sitio utiliza cookies o otras herramientas tÃ©cncias y, previo consentimiento, tambiÃ©n cookies de perfil u otras herramientas de seguimiento, tambiÃ©n de terceros, para enviarte publicidad personalizada y ofrecerte servicios en lÃ­nea con tus preferencias, asÃ­ como la supervisiÃ³n del comportamiento de los visitantes. Si quieres saber mÃ¡s, consulta la <a href="/legal/cookie">PolÃ­tica de Cookies</a></p><p>Si cierras este banner pinchando en la Â«Rechazar todoÂ», seguirÃ¡s navegando por el sitio sin cookies ni otras herramientas de seguimiento que no sean las tÃ©cnicas.</p>',
    'button':'Aceptar todas las cookies',
    'rifiuta':'Rechazar todo'
  },
  'doi_popup':{
    'complimenti':'Â¡Bien hecho!',
    'attiva_account': 'Activa tu cuenta',
    'conferma': 'Confirma la direcciÃ³n ahora',
    'titolo':'Tu perfil en $servizio$ ha sido creado con Ã©xito',
    'descrizione': 'Te hemos enviado un correo electrÃ³nico a:',
    'indirizzo_indicato':'Tu correo electrÃ³nico:',
    'se_sbagliata':'Si ha ingresado la direcciÃ³n incorrecta, puede cambiarla ingresando la correcta en el siguiente campo y haciendo clic en "EnvÃ­ar"',
    'cambia_mail':'Cambiar la direcciÃ³n de correo electrÃ³nico',
    'invia':'Cambiar',
    'errore_stessa_mail':'Ingresaste el mismo correo. Ya te hemos enviado el mensaje a esa direcciÃ³n. Por favor espera o revisa tu carpeta de spam',
    'importante':'Importante:',
    'messaggio_ok':'Hemos enviado un mensaje a la nueva direcciÃ³n de correo electrÃ³nico.',
    'errore_su_cambio_email':'no fue posible cambiar el correo electronico',
    'punto1':'<strong>Verifique</strong> su carpeta <strong>"Spam / Junk Mail"</strong> para asegurarse de que el correo electrÃ³nico no haya llegado allÃ­',
    'punto2':'El correo electrÃ³nico de activaciÃ³n puede tardar hasta 5 minutos en llegar.',
    'punto3':'MÃ¡rcanos como <strong>"No es spam/Correo no deseado"</strong> para asegurarte de recibir todos los correos electrÃ³nicos importantes de $servizio$'

  },
  'find':{
    'donne_disponibili':'Mujeres Disponibles en el Ã¡rea de'
  },
  'tooltip':{
    'titolo_attiva_notifiche':'ðŸ’Œ Activar las notificaciones',
    'attiva_notifiche':'No pierdas la oportunidad de conocer a las mujeres que te escriben o visitan tu perfil. Â¡Activa las notificaciones de inmediato, tendrÃ¡s mÃ¡s posibilidades de acertar en el objetivo! ðŸ˜',
    'bottone_attiva_notifiche':'Activar ahora!'
  },
  'unsubscribe':{
      'titolo':'Darse de baja de la Newsletter',
      'sottotitolo':'Lamentamos saber que deseas darte de baja de nuestra newsletter. Haz clic en el botÃ³n de abajo para confirmar tu baja. Â¡Si cambias de opiniÃ³n, siempre puedes volver a suscribirte en el futuro!',
      'testo_bottone':'Darse de baja',
      'testo_popup':'<strong>Â¡Baja realizada con Ã©xito!</strong><br> SerÃ¡s redirigido a la pÃ¡gina principal del sitio'
    },
    'match':{
      'manda_invito':'Enviar una invitaciÃ³n',
      'anni':'aÃ±os',
      'su_di_me':'Sobre mÃ­'
    },
    'recensioni':{
      'cosa_dicono':'<strong>Lo que</strong> dicen los usuarios en la web'
    }
}
